import React, { useState, useEffect } from "react";
import { Validation } from '../../utils/validation';
import { MAIL_FORMAT } from '../../utils/common';
import ShareMessageModal from './ShareMessageModal';
import './Modal.css';

const SharePurchaseOrderModal = ({ isShow, onClose, onShare }) => {
    const [fields, setFields] = useState({ email: 'orders@techtopind.com' });
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showShareMessageModal, setShowShareMessageModal] = useState(false);

    useEffect(() => {
        if (isShow) {
            setFields({ email: 'orders@techtopind.com' });
            setErrors({});
            setSuccessMessage('');
            setErrorMessage('');
        }
    }, [isShow]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields({ ...fields, [name]: value });
        setErrors({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = Validation(fields, ['email']);
        if (fields.cc && fields.cc.trim()) {
            const ccList = fields.cc.split(',').map(c => c.trim()).filter(Boolean);
            for (let c of ccList) {
                if (!MAIL_FORMAT.test(c)) {
                    validationErrors.cc = 'CC email address is invalid.';
                    break;
                }
            }
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const email = fields.email;
        const note = fields.note;
        const cc = fields.cc;

        // Hide modal immediately so it does not stay visible behind loader
        onClose();

        try {
            await onShare(email, note, cc);
        } catch (err) {
            console.error("Error sharing purchase order:", err);
        }
    };

    return (
        <>
            {isShow && (
                <div className="motor-modal-overlay" onClick={onClose}>
                    <div
                        className="motor-modal-content"
                        style={{ maxWidth: '560px', width: '90%', padding: 0 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Modal Header */}
                        <div className="modal-header-dark">
                            <h4 className="m-0">
                                Submit PO
                            </h4>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>
                        </div>

                        <form onSubmit={handleSubmit} className="d-flex flex-column flex-grow-1 m-0" style={{ minHeight: 0, overflow: 'hidden' }}>
                            {/* Modal Body */}
                            <div className="modal-body-content d-flex flex-column gap-3" style={{ padding: '20px' }}>
                                <div className="form-group">
                                    <label htmlFor="email" className="fw-semibold">Email</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="email"
                                        id="email"
                                        value={fields.email || 'orders@techtopind.com'}
                                        onChange={handleChange}
                                        readOnly
                                        placeholder="orders@techtopind.com"
                                    />
                                    {errors.email && (
                                        <div className="text-danger small mt-1">{errors.email}</div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="cc" className="fw-semibold">CC</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="cc"
                                        id="cc"
                                        value={fields.cc || ''}
                                        onChange={handleChange}
                                        placeholder="cc@example.com (optional)"
                                    />
                                    {errors.cc && (
                                        <div className="text-danger small mt-1">{errors.cc}</div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <span className="text-muted small">
                                        Please add special notes for your customer to see. These notes will appear in the body of the email.
                                    </span>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="note" className="fw-semibold">Note</label>
                                    <textarea
                                        className="form-control"
                                        name="note"
                                        id="note"
                                        onChange={handleChange}
                                        rows="4"
                                        value={fields.note || ''}
                                        placeholder="Special notes..."
                                    ></textarea>
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer-dark">
                                <button
                                    type="button"
                                    className="btn btn-secondary px-4"
                                    onClick={onClose}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary px-4"
                                    style={{ backgroundColor: '#bb5d40', borderColor: '#bb5d40' }}
                                >
                                    Share
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <ShareMessageModal
                isShow={showShareMessageModal}
                successMessage={successMessage}
                errorMessage={errorMessage}
                onClose={() => setShowShareMessageModal(false)}
            />
        </>
    );
};

export default SharePurchaseOrderModal;